import { DatePipe } from '@angular/common';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GlobalComponent } from 'src/app/global/global.component';
import { clientonboardBO } from './client-onboarding.model';

@Component({
  selector: 'app-client-onboarding',
  templateUrl: './client-onboarding.component.html',
  styleUrls: ['./client-onboarding.component.scss']
})

export class ClientOnboardingComponent implements OnInit {
  @Input() clientonboardBO = new clientonboardBO();
  @Output() dataEmitFromOnboard = new EventEmitter<clientonboardBO>();

  constructor(public router: Router, public datepipe: DatePipe, public global: GlobalComponent, public ngxService: NgxUiLoaderService) {

  }

  ngOnInit(): void {
  }

  backToClientOnboardingList() {
    this.ngxService.start();
    this.clientonboardBO.edit = false;
    this.dataEmitFromOnboard.emit(this.clientonboardBO);
    this.global.docbool = false;
    this.ngxService.stop();
  }

  onSaveCompleted(value) {
    if(value = true)
      this.backToClientOnboardingList();
  }

}